import { Link, useParams } from "react-router-dom";
import { Box, Button, Container, Grid2, Typography, TextField, Card, CardContent, Alert } from '@mui/material';
import { useAuth } from '../AuthContext';
import { useEffect, useState } from "react";

export default function ResetPassword() {
  const params = useParams();
  const auth = useAuth();
  const [isPending, setIsPending] = useState(true);
  const [tokenError, setTokenError] = useState();
  const [errorFeedback, setErrorFeedback] = useState();
  const [formLoading, setFormLoading] = useState();
  const [formSuccess, setFormSuccess] = useState();


  function handleSubmit(event) {
    event.preventDefault();

    const formData = new FormData(event.currentTarget);
    const password = formData.get("password");
    const password2 = formData.get("password2");
    if (password?.length < 8) {
      setErrorFeedback('Password must be at least 8 characters');
      return;
    }
    if (password !== password2) {
      setErrorFeedback('Passwords do not match');
      return;
    }
    setFormLoading(true);
    auth.request('/api/user/reset-password', { token: params.token, password, password2 }).then((resp) => {
      console.log(resp);
      if (resp.status === 200) {
        setFormSuccess(true);
      } else {
        setErrorFeedback(resp.error || 'Unable to reset password');
      }
      setFormLoading(false);
    }).catch(error => {
      setErrorFeedback(error.message);
      console.log('error', error);
      setFormLoading(false);
    });
  }

  useEffect(() => {
    auth.request('/api/user/verify-token', { token: params.token }).then(res => {
      console.log('response', res);
      if (res.status !== 200) {
        setTokenError(res.data.error || 'Unable to validate reset token');  
      }
      setIsPending(false);
    }).catch(err => {
      console.log(err);
      setTokenError('Unable to validate reset token');
      setIsPending(false);
    });
  }, []);

  if (isPending) {
    return null;
  }

  return (
    <Container maxWidth="sm" sx={{ p: 3 }}>
      <Typography variant="h3">Reset Password</Typography>
      <Typography sx={{ my: 3 }}>Set a new password for your account.</Typography>

      {formSuccess ? (
        <Alert
          action={
            <Button to="/login" component={Link} color="inherit" size="small">
              Log In
            </Button>
          }        
          severity="success"
        >A new password has been set. Please log-in to your account with your new password.</Alert>
      ) : (
        tokenError ? (
          <Alert severity="error">{tokenError || 'An unknown error occurred'}</Alert>
        ) : (
          <form onSubmit={handleSubmit}>
            <Grid2 container direction="column" spacing={3}>
              <Grid2>
                <TextField
                  name="password"
                  type="password"
                  label="Create New Password"
                  disabled={formLoading}
                  fullWidth
                  required
                  error={!!errorFeedback}
                />
              </Grid2>
              <Grid2>
                <TextField
                  name="password2"
                  type="password"
                  label="Confirm New Password"
                  disabled={formLoading}
                  fullWidth
                  required
                  error={!!errorFeedback}
                  helperText={errorFeedback}
                />
              </Grid2>
            </Grid2>
            <Grid2 container sx={{ mt: 2 }}>
              <Grid2>
                <Button disabled={formLoading} type="submit" color="primary" variant="outlined">Set Password</Button>
              </Grid2>
            </Grid2>
          </form>
        )
      )}
    </Container>
  );
}
